import { Component, Input, OnInit } from '@angular/core';
import { Annotation } from '../../models/Annotation';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';
import { LoginService } from '../../services/Login.service';
import { MatDialog } from '@angular/material/dialog';
import { HttpcallService } from '../../services/httpcall.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-annotation-records-print-prv',
  templateUrl: './annotation-records-print-prv.component.html'
})
export class AnnotationRecordsPrintPrvComponent implements OnInit{

  constructor(private loginService: LoginService, private httpCallService: HttpcallService, private route: Router,
    public commonDataService: CommonDataService, private graphQlService: GraphqlService,
    public dialog: MatDialog) {
  }
  @Input() paragraphId: string = "";
  @Input() lineBool: string = "";
  @Input() annotations: any[] = [];
  @Input() annotationWithInContent: boolean = false;
  @Input() labels: any;
  @Input() isParaNum: boolean = true;
  @Input() UserInfo: any;
  shareLinkLabel: string;
  editLinkLabel: string;
  deleteLinkLabel: string;
  versionTextLabel: string;
  addedTextLabel: string;
  userId: string = "";
  annotationContent: Annotation[] = [];

  ngOnInit(): void {
    this.getUserId();
    this.getYourAnnotationLabel();
    this.commonDataService.updateAnnotationParagraphId.subscribe(data => {
      if (data == this.paragraphId) {
        this.getUserId();
      }
    })
    this.commonDataService.addAnnotationParagraphId.subscribe(data => {
      if (data == this.paragraphId) {
        this.getUserId();
      }
    })
  }

  getYourAnnotationLabel() {
    this.labels = this.labels?.filter(x => x.key.trim());
    this.shareLinkLabel = this.labels?.filter(x => x.key == "global_share").map(y => y.value);
    this.editLinkLabel = this.labels?.filter(x => x.key == "global_edit").map(y => y.value);
    this.deleteLinkLabel = this.labels?.filter(x => x.key == "global_delete").map(y => y.value);
    this.versionTextLabel = this.labels?.filter(x => x.key == "global_version").map(y => y.value);
    this.addedTextLabel = this.labels?.filter(x => x.key == "global_added").map(y => y.value);
  }

  getAnnotation() {
    this.httpCallService.getAnnotation(this.paragraphId, "false").subscribe((resp: any) => {
      this.annotationContent = resp;
      setTimeout(() => {
        let str = `<div>`;
        var hide = document.getElementsByClassName("print-content-hide")
        Array.prototype.forEach.call(hide, function (obj) {
          obj.style.display = "none"
        });
        var contents = document.getElementsByClassName("print-all-content");
        Array.prototype.forEach.call(contents, function (element) {
          str += `<div> ${element.innerHTML} </div>`;
        });
        str += '</div>'
        setTimeout(() => {
          document.getElementById("printPreviewArticle").innerHTML = "";
          document.getElementById("printPreviewArticle").innerHTML += str;
          document.getElementById("pageHeadingprint").innerHTML = document.getElementById("pageHeading").innerHTML;
          document.getElementById("pageHeadingprint").className = document.getElementById("pageHeading").classList.value;
          this.commonDataService.showLoader.next(false);
          this.commonDataService.printwithannotations.next("");
        }, 500)
      }, 500)
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  getUserId() {
    this.commonDataService.userId.next(this.UserInfo?.user?.userName);
    this.userId = this.UserInfo?.user?.userName;
    if (!this.annotationWithInContent) {
      this.getAnnotation();
    } else {
      this.annotationContent = this.annotations;
      setTimeout(() => {
        let str = `<div>`;
        var hide = document.getElementsByClassName("print-content-hide")
        Array.prototype.forEach.call(hide, function (obj) {
          obj.style.display = "none"
        });
        var contents = document.getElementsByClassName("print-all-content");
        Array.prototype.forEach.call(contents, function (element) {
          str += `<div> ${element.innerHTML} </div>`;
        });
        var footnoteContent = document.getElementsByClassName("print-all-footnote-content");
        if (footnoteContent.length > 0) {
          str += `<div> <hr /> </div>`;
        }
        Array.prototype.forEach.call(footnoteContent, function (element) {
          str += `<div> ${element.innerHTML} </div>`;
        });
        str += '</div>'
        Array.prototype.forEach.call(hide, function (obj) {
          obj.style.display = "flex";
        });
        setTimeout(() => {
          document.getElementById("printPreviewArticle").innerHTML = "";
          document.getElementById("printPreviewArticle").innerHTML += str;
          //const pageHeading = document.getElementById("pageHeading");
          //if (!this.route.url.includes("finalpronouncements")) {
            //if (pageHeading?.innerHTML) {
            //    document.getElementById("pageHeadingprint").innerHTML = pageHeading.innerHTML;
            //    document.getElementById("pageHeadingprint").className = document.getElementById("pageHeading").classList.value;
            //}
          //}
        }, 1000)
      }, 500)
    }
  }

}
